// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const ForgotPasswordLoader = Loadable({
  loader: () => import('./ForgotPasswordScreenContainer'),
  loading: Loader,
})

export default ForgotPasswordLoader
